
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dJVgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95299be710b4e4ff$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $hbBKK = parcelRequire("hbBKK");

var $9g0oR = parcelRequire("9g0oR");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("5goCs");
var $epQac = parcelRequire("epQac");
const $95299be710b4e4ff$var$JiraLogo = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
const $95299be710b4e4ff$var$JiraSoftwareNav = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const solutionsDropdownStyles = (0, $iSvIT.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/marketing");
    const engineeringHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/engineering");
    const designHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/design");
    const operationsHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/operations");
    const itHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/it");
    // Use Cases Hrefs
    const planningHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/planning");
    const campaignManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/campaign-management");
    const agileProjectManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/agile-project-management");
    const programManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/program-management");
    //Company Size Hrefs
    const enterpriseHref = (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise");
    const solutionsDropdown = (0, $iSvIT.useMemo)(()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.teams.header",
                        defaultMessage: "Teams"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.marketing",
                                defaultMessage: "Marketing"
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.engineering",
                                defaultMessage: "Engineering"
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.design",
                                defaultMessage: "Design"
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.operations",
                                defaultMessage: "Operations"
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.it",
                                defaultMessage: "IT"
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.useCases.header",
                        defaultMessage: "Use Cases"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.planning",
                                defaultMessage: "Planning"
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.campaign-management",
                                defaultMessage: "Campaign Management"
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.agile-project-management",
                                defaultMessage: "Agile Project Management"
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.program-management",
                                defaultMessage: "Program Management"
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.companySize.header",
                        defaultMessage: "Company Size"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.companySize.enterprise",
                                defaultMessage: "Enterprise"
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const featuresHref = (0, $3FBn4.useLocalizedHref)("/software/jira/features");
    const productGuideHref = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const templatesHref = (0, $3FBn4.useLocalizedHref)("/software/jira/templates");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/jira/pricing");
    const productLogoHref = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const templateCategoriesShown = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraTemplatesDxpMigration);
    const templatesLinkContent = (0, $iSvIT.useMemo)(()=>{
        const common = {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.templates",
                defaultMessage: "Templates"
            }),
            productKey: "jira"
        };
        return templateCategoriesShown ? {
            ...common,
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $epQac.TemplateCategoriesDropdown), {}),
            dropdownType: "templates",
            containerPosition: "relative"
        } : {
            ...common,
            hasSubnav: false,
            href: templatesHref
        };
    }, [
        templatesHref,
        templateCategoriesShown
    ]);
    const newLinks = (0, $iSvIT.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: featuresHref
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                productKey: "jira",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                dropdownType: "solutions",
                content: solutionsDropdown
            },
            {
                globalLinksKey: "productGuide",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            }
        ], [
        intl,
        featuresHref,
        solutionsDropdown,
        solutionsDropdownStyles,
        productGuideHref,
        templatesHref,
        pricingHref
    ]);
    const links = (0, $iSvIT.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: featuresHref
            },
            {
                globalLinksKey: "productGuide",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            },
            {
                globalLinksKey: "enterprise",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: enterpriseHref
            }
        ], [
        enterpriseHref,
        featuresHref,
        intl,
        pricingHref,
        productGuideHref,
        templatesHref
    ]);
    const globalNavItemKeys = (0, $iSvIT.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: productLogoHref,
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($95299be710b4e4ff$var$JiraLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "JiraeSoftwarePageTemplate.navbar.getitfree",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($95299be710b4e4ff$var$JiraLogo, {}),
            navigationTrynowCtaText: intl.formatMessage({
                id: "JiraFeatureSoftwarePageTemplate.heroCTA",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            productPageNavLinks: newLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira",
                    mobileLinksProps: newLinks
                }
            ],
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: newLinks.find((link)=>link.globalLinksKey === "solutions")?.content
                },
                {
                    menuPageKey: "templates",
                    menuPageObjects: newLinks.find((link)=>link.globalLinksKey === "templates")?.content
                }
            ]
        })
    });
};
$95299be710b4e4ff$var$JiraSoftwareNav.displayName = "JiraSoftwareNav";
var $95299be710b4e4ff$export$2e2bcd8739ae039 = $95299be710b4e4ff$var$JiraSoftwareNav;

});
parcelRegister("5goCs", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return (parcelRequire("epQac")).TemplateCategoriesDropdown; });
parcelRequire("epQac");

});
parcelRegister("epQac", function(module, exports) {

$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return $b829a312c9341cb7$export$8bb7e16f8f8a7ba6; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $9g0oR = parcelRequire("9g0oR");
parcelRequire("jF7is");
var $ijtPZ = parcelRequire("ijtPZ");
const $b829a312c9341cb7$export$8bb7e16f8f8a7ba6 = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const intl = (0, $f6qj2.default)();
    const { data: data } = (0, $ijtPZ.useJiraTemplateCategoriesSingleton)();
    const allTemplateLink = {
        text: intl.formatMessage({
            id: "ira.TemplateCategoriesDropdown.allTemplates",
            defaultMessage: "All templates"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/templates",
            locale: locale
        })
    };
    const templateLinks = data.map((category)=>({
            text: category.categoryNameExternal,
            href: (0, $3FBn4.getLocalizedHref)({
                href: `/software/jira/templates/${category.urlSlug}`,
                locale: locale
            })
        }));
    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: "Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates",
            defaultMessage: "Jira Service Management templates"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/templates/service-management",
            locale: locale
        }),
        anchorProps: {
            target: "_blank"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allTemplateLink,
                    ...templateLinks
                ]
            },
            {
                links: [
                    jsmTemplatesLink
                ]
            }
        ]
    });
};

});
parcelRegister("jF7is", function(module, exports) {
$parcel$export(module.exports, "getTemplateCategories", function () { return (parcelRequire("8FQ7c")).getTemplateCategories; });
$parcel$export(module.exports, "useJiraTemplateCategoriesSingleton", function () { return (parcelRequire("ijtPZ")).useJiraTemplateCategoriesSingleton; });
parcelRequire("8FQ7c");
parcelRequire("ijtPZ");

});
parcelRegister("8FQ7c", function(module, exports) {

$parcel$export(module.exports, "getTemplateCategories", function () { return $439693367266da4f$export$819167f3de5f32cb; });

var $8uI7J = parcelRequire("8uI7J");

var $kNCWT = parcelRequire("kNCWT");
const $439693367266da4f$var$JIRA_PRODUCT_INTERNAL_TITLE = "Jira Cloud Product";
const $439693367266da4f$export$52bf0b65d881440d = (0, $8uI7J.gql)`
query {
  taxonomyTemplateCategoryCollection(
    limit: 100,
    where: {
      product: {
        internalTitle: "${$439693367266da4f$var$JIRA_PRODUCT_INTERNAL_TITLE}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`;
const $439693367266da4f$export$819167f3de5f32cb = ()=>{
    return (0, $8uI7J.request)({
        url: (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL),
        document: $439693367266da4f$export$52bf0b65d881440d,
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};

});
parcelRegister("8uI7J", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $62f35a1981edc458$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "gql", function () { return $62f35a1981edc458$export$72e4926bf8358653; });

var $ivMJx = parcelRequire("ivMJx");

var $JLOKZ = parcelRequire("JLOKZ");

var $hROKM = parcelRequire("hROKM");

var $jL8SY = parcelRequire("jL8SY");

var $CkZoA = parcelRequire("CkZoA");

var $15H2u = parcelRequire("15H2u");

var $jAmKY = parcelRequire("jAmKY");
/**
 * Convert the given headers configuration into a plain object.
 */ const $62f35a1981edc458$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $15H2u && $15H2u.Headers && headers instanceof $15H2u.Headers) oHeaders = (0, $JLOKZ.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $62f35a1981edc458$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $62f35a1981edc458$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($62f35a1981edc458$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $62f35a1981edc458$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $62f35a1981edc458$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $62f35a1981edc458$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $62f35a1981edc458$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? (0, $ivMJx.defaultJsonSerializer)
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $62f35a1981edc458$export$b0f268a6eae2cdf1 {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $hROKM.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($15H2u))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $jL8SY.resolveRequestDocument)(rawRequestOptions.query);
            return $62f35a1981edc458$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$62f35a1981edc458$var$resolveHeaders($62f35a1981edc458$var$callOrIdentity(headers)),
                    ...$62f35a1981edc458$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $hROKM.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($15H2u))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $jL8SY.resolveRequestDocument)(requestOptions.document);
        return $62f35a1981edc458$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$62f35a1981edc458$var$resolveHeaders($62f35a1981edc458$var$callOrIdentity(headers)),
                ...$62f35a1981edc458$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $hROKM.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $jL8SY.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $62f35a1981edc458$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$62f35a1981edc458$var$resolveHeaders($62f35a1981edc458$var$callOrIdentity(headers)),
                ...$62f35a1981edc458$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? (0, (/*@__PURE__*/$parcel$interopDefault($15H2u))),
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
const $62f35a1981edc458$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $62f35a1981edc458$var$createHttpMethodFetcher((0, $JLOKZ.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $62f35a1981edc458$var$getResult(response, fetchOptions.jsonSerializer ?? (0, $ivMJx.defaultJsonSerializer));
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new (0, $CkZoA.ClientError)(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $62f35a1981edc458$export$3052fa16c23a17ef = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $hROKM.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $62f35a1981edc458$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
// prettier-ignore
// eslint-disable-next-line
async function $62f35a1981edc458$export$b5fe3f66a567bec0(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $hROKM.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $62f35a1981edc458$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $62f35a1981edc458$export$72420c3222c11ca1 = async (...args)=>{
    const params = $62f35a1981edc458$var$parseBatchRequestsArgsExtended(args);
    const client = new $62f35a1981edc458$export$b0f268a6eae2cdf1(params.url);
    return client.batchRequests(params);
};
const $62f35a1981edc458$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $62f35a1981edc458$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? (0, $ivMJx.defaultJsonSerializer);
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $62f35a1981edc458$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $62f35a1981edc458$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
const $62f35a1981edc458$export$72e4926bf8358653 = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
var $62f35a1981edc458$export$2e2bcd8739ae039 = $62f35a1981edc458$export$b5fe3f66a567bec0;

});
parcelRegister("ivMJx", function(module, exports) {

$parcel$export(module.exports, "defaultJsonSerializer", function () { return $d7a0ecb8e299b77e$export$94978876ea00418f; });
const $d7a0ecb8e299b77e$export$94978876ea00418f = JSON;

});

parcelRegister("JLOKZ", function(module, exports) {

$parcel$export(module.exports, "uppercase", function () { return $08994bacd5047984$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "HeadersInstanceToPlainObject", function () { return $08994bacd5047984$export$8cbbf7c85c69d7bd; });
const $08994bacd5047984$export$6cfe151e6b925e83 = (str)=>str.toUpperCase();
const $08994bacd5047984$export$8cbbf7c85c69d7bd = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};

});

parcelRegister("hROKM", function(module, exports) {

$parcel$export(module.exports, "parseRequestArgs", function () { return $d01ec17fb49070da$export$23fbebc38045fef1; });
$parcel$export(module.exports, "parseRawRequestArgs", function () { return $d01ec17fb49070da$export$915c311301d24138; });
$parcel$export(module.exports, "parseBatchRequestArgs", function () { return $d01ec17fb49070da$export$db48f1a2d994371; });
$parcel$export(module.exports, "parseRequestExtendedArgs", function () { return $d01ec17fb49070da$export$77a1c1c6dd0fc83d; });
$parcel$export(module.exports, "parseRawRequestExtendedArgs", function () { return $d01ec17fb49070da$export$7dbb6e4001743509; });
const $d01ec17fb49070da$export$23fbebc38045fef1 = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $d01ec17fb49070da$export$915c311301d24138 = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $d01ec17fb49070da$export$db48f1a2d994371 = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $d01ec17fb49070da$export$77a1c1c6dd0fc83d = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $d01ec17fb49070da$export$7dbb6e4001743509 = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};

});

parcelRegister("jL8SY", function(module, exports) {

$parcel$export(module.exports, "resolveRequestDocument", function () { return $e6294ca186705ea8$export$8a71244cbc138170; });

var $7zqoA = parcelRequire("7zqoA");
var $7kZQf = parcelRequire("7kZQf");
/**
 * helpers
 */ const $e6294ca186705ea8$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $e6294ca186705ea8$export$8a71244cbc138170 = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $7zqoA.parse)(document);
            operationName = $e6294ca186705ea8$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $e6294ca186705ea8$var$extractOperationName(document);
    return {
        query: (0, $7kZQf.print)(document),
        operationName: operationName
    };
};

});

parcelRegister("CkZoA", function(module, exports) {

$parcel$export(module.exports, "ClientError", function () { return $0733d4c0c2bfc33f$export$bb8c263ad32caa8; });
class $0733d4c0c2bfc33f$export$bb8c263ad32caa8 extends Error {
    constructor(response, request){
        const message = `${$0733d4c0c2bfc33f$export$bb8c263ad32caa8.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $0733d4c0c2bfc33f$export$bb8c263ad32caa8.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $0733d4c0c2bfc33f$export$bb8c263ad32caa8);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}

});

parcelRegister("15H2u", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("jAmKY", function(module, exports) {
/* eslint-disable */ 
var $jL8SY = parcelRequire("jL8SY");

var $CkZoA = parcelRequire("CkZoA");
// import type WebSocket from 'ws'
const $e423081645065d58$var$CONNECTION_INIT = `connection_init`;
const $e423081645065d58$var$CONNECTION_ACK = `connection_ack`;
const $e423081645065d58$var$PING = `ping`;
const $e423081645065d58$var$PONG = `pong`;
const $e423081645065d58$var$SUBSCRIBE = `subscribe`;
const $e423081645065d58$var$NEXT = `next`;
const $e423081645065d58$var$ERROR = `error`;
const $e423081645065d58$var$COMPLETE = `complete`;
class $e423081645065d58$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $e423081645065d58$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $e423081645065d58$export$5eb90cb6288c26cf {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($e423081645065d58$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $e423081645065d58$var$parseMessage(e.data);
                switch(message.type){
                    case $e423081645065d58$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $e423081645065d58$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($e423081645065d58$var$Pong(r).text));
                        else socket.send($e423081645065d58$var$Pong(null).text);
                        return;
                    case $e423081645065d58$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $e423081645065d58$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new (0, $CkZoA.ClientError)({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $e423081645065d58$var$ERROR:
                        subscriber.error && subscriber.error(new (0, $CkZoA.ClientError)({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $e423081645065d58$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($e423081645065d58$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($e423081645065d58$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $jL8SY.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($e423081645065d58$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$e423081645065d58$export$5eb90cb6288c26cf.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function $e423081645065d58$var$parseMessage(data, f = (a)=>a) {
    const m = $e423081645065d58$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $e423081645065d58$var$ConnectionInit(payload) {
    return new $e423081645065d58$var$GraphQLWebSocketMessage($e423081645065d58$var$CONNECTION_INIT, payload);
}
function $e423081645065d58$var$Ping(payload) {
    return new $e423081645065d58$var$GraphQLWebSocketMessage($e423081645065d58$var$PING, payload, undefined);
}
function $e423081645065d58$var$Pong(payload) {
    return new $e423081645065d58$var$GraphQLWebSocketMessage($e423081645065d58$var$PONG, payload, undefined);
}
function $e423081645065d58$var$Subscribe(id, payload) {
    return new $e423081645065d58$var$GraphQLWebSocketMessage($e423081645065d58$var$SUBSCRIBE, payload, id);
}
function $e423081645065d58$var$Complete(id) {
    return new $e423081645065d58$var$GraphQLWebSocketMessage($e423081645065d58$var$COMPLETE, undefined, id);
}

});



parcelRegister("ijtPZ", function(module, exports) {

$parcel$export(module.exports, "useJiraTemplateCategoriesSingleton", function () { return $d9bdcf0f19bc293e$export$d081425972902bb3; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("d1Wot");
var $aaTL5 = parcelRequire("aaTL5");
parcelRequire("jF7is");
var $8FQ7c = parcelRequire("8FQ7c");
const $d9bdcf0f19bc293e$export$ef1e726410cc2d37 = ()=>{
    const [data, setData] = (0, $iSvIT.useState)([]);
    const [loading, setLoading] = (0, $iSvIT.useState)(false);
    const [error, setError] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const data = await (0, $8FQ7c.getTemplateCategories)();
                setData(data.taxonomyTemplateCategoryCollection.items ?? []);
            } catch (err) {
                setError(err);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    return {
        data: data,
        loading: loading,
        error: error
    };
};
const $d9bdcf0f19bc293e$var$init = {
    data: [],
    loading: false,
    error: null
};
const $d9bdcf0f19bc293e$export$d081425972902bb3 = (0, $aaTL5.singletonHook)($d9bdcf0f19bc293e$var$init, $d9bdcf0f19bc293e$export$ef1e726410cc2d37);

});
parcelRegister("d1Wot", function(module, exports) {

$parcel$export(module.exports, "singletonHook", function () { return (parcelRequire("aaTL5")).singletonHook; });

var $aaTL5 = parcelRequire("aaTL5");

var $214nj = parcelRequire("214nj");
var $97c8aa2148153fcf$var$ReactSingletonHook = {
    singletonHook: (0, $aaTL5.singletonHook),
    SingletonHooksContainer: (0, $214nj.SingletonHooksContainer)
};
var $97c8aa2148153fcf$export$2e2bcd8739ae039 = $97c8aa2148153fcf$var$ReactSingletonHook;

});
parcelRegister("aaTL5", function(module, exports) {

$parcel$export(module.exports, "singletonHook", function () { return $7686170018230750$export$3a39c3b76a1163bc; });

var $iSvIT = parcelRequire("iSvIT");

var $214nj = parcelRequire("214nj");

var $5LIXH = parcelRequire("5LIXH");
var $7686170018230750$export$3a39c3b76a1163bc = function singletonHook(initValue, useHookBody, options) {
    if (options === void 0) options = {};
    var mounted = false;
    var removeHook = undefined;
    var initStateCalculated = false;
    var lastKnownState = undefined;
    var consumers = [];
    var _options = options, _options$unmountIfNoC = _options.unmountIfNoConsumers, unmountIfNoConsumers = _options$unmountIfNoC === void 0 ? false : _options$unmountIfNoC;
    var applyStateChange = function applyStateChange(newState) {
        lastKnownState = newState;
        (0, $5LIXH.batch)(function() {
            return consumers.forEach(function(c) {
                return c(newState);
            });
        });
    };
    var stateInitializer = function stateInitializer() {
        if (!initStateCalculated) {
            lastKnownState = typeof initValue === "function" ? initValue() : initValue;
            initStateCalculated = true;
        }
        return lastKnownState;
    };
    return function() {
        var _useState = (0, $iSvIT.useState)(stateInitializer), state = _useState[0], setState = _useState[1];
        (0, $iSvIT.useEffect)(function() {
            if (!mounted) {
                mounted = true;
                removeHook = (0, $214nj.addHook)({
                    initValue: initValue,
                    useHookBody: useHookBody,
                    applyStateChange: applyStateChange
                });
            }
            consumers.push(setState);
            if (lastKnownState !== state) setState(lastKnownState);
            return function() {
                consumers.splice(consumers.indexOf(setState), 1);
                if (consumers.length === 0 && unmountIfNoConsumers) {
                    removeHook();
                    mounted = false;
                }
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return state;
    };
};

});
parcelRegister("214nj", function(module, exports) {

$parcel$export(module.exports, "SingletonHooksContainer", function () { return $177f118e50700877$export$5ab4f3edf2efdc2b; });
$parcel$export(module.exports, "addHook", function () { return $177f118e50700877$export$f99777bb87ac6904; });

var $iSvIT = parcelRequire("iSvIT");

var $dSsUz = parcelRequire("dSsUz");

var $5LIXH = parcelRequire("5LIXH");

var $f5IT8 = parcelRequire("f5IT8");
function $177f118e50700877$var$_extends() {
    $177f118e50700877$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $177f118e50700877$var$_extends.apply(this, arguments);
}
var $177f118e50700877$var$nextKey = 1;
var $177f118e50700877$var$automaticRender = false;
var $177f118e50700877$var$manualRender = false;
var $177f118e50700877$var$workingSet = [];
var $177f118e50700877$var$renderedContainers = [];
var $177f118e50700877$var$notifyContainersAsync = function notifyContainersAsync() {
    $177f118e50700877$var$renderedContainers.forEach(function(updateRenderedHooks) {
        return updateRenderedHooks();
    });
};
var $177f118e50700877$export$5ab4f3edf2efdc2b = function SingletonHooksContainer(_ref) {
    var automaticContainerInternalUseOnly = _ref.automaticContainerInternalUseOnly;
    var _useState = (0, $iSvIT.useState)([]), hooks = _useState[0], setHooks = _useState[1];
    var currentHooksRef = (0, $iSvIT.useRef)();
    currentHooksRef.current = hooks;
    // if there was no automaticRender, and this one is not automatic as well
    if (!automaticContainerInternalUseOnly && $177f118e50700877$var$automaticRender === false) $177f118e50700877$var$manualRender = true;
    (0, $iSvIT.useEffect)(function() {
        var mounted = true;
        function updateRenderedHooks() {
            if (!mounted) return;
            if ($177f118e50700877$var$renderedContainers[0] !== updateRenderedHooks) {
                if (!automaticContainerInternalUseOnly && $177f118e50700877$var$automaticRender === true) (0, $f5IT8.warning)("SingletonHooksContainer is mounted after some singleton hook has been used.Your SingletonHooksContainer will not be used in favor of internal one.");
                setHooks(function(_) {
                    return [];
                });
                return;
            }
            setHooks([].concat($177f118e50700877$var$workingSet));
        }
        $177f118e50700877$var$renderedContainers.push(updateRenderedHooks);
        $177f118e50700877$var$notifyContainersAsync();
        return function() {
            mounted = false;
            if (currentHooksRef.current.length > 0) (0, $f5IT8.warning)("SingletonHooksContainer is unmounted, but it has active singleton hooks. They will be reevaluated once SingletonHooksContainer is mounted again");
            $177f118e50700877$var$renderedContainers.splice($177f118e50700877$var$renderedContainers.indexOf(updateRenderedHooks), 1);
            $177f118e50700877$var$notifyContainersAsync();
        };
    }, [
        automaticContainerInternalUseOnly
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, hooks.map(function(_ref2) {
        var hook = _ref2.hook, key = _ref2.key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dSsUz.SingleItemContainer), $177f118e50700877$var$_extends({}, hook, {
            key: key
        }));
    }));
};
var $177f118e50700877$export$f99777bb87ac6904 = function addHook(hook) {
    var key = $177f118e50700877$var$nextKey++;
    $177f118e50700877$var$workingSet.push({
        hook: hook,
        key: key
    });
    // no container and no previous manually rendered containers
    if ($177f118e50700877$var$renderedContainers.length === 0 && $177f118e50700877$var$manualRender === false) {
        $177f118e50700877$var$automaticRender = true;
        (0, $5LIXH.mount)($177f118e50700877$export$5ab4f3edf2efdc2b);
    }
    $177f118e50700877$var$notifyContainersAsync();
    return function() {
        $177f118e50700877$var$workingSet.splice($177f118e50700877$var$workingSet.findIndex(function(h) {
            return h.key === key;
        }), 1);
        $177f118e50700877$var$notifyContainersAsync();
    };
};
var $177f118e50700877$export$266927115b25305a = function resetLocalStateForTests() {
    $177f118e50700877$var$automaticRender = false;
    $177f118e50700877$var$manualRender = false;
    $177f118e50700877$var$workingSet.splice(0, $177f118e50700877$var$workingSet.length);
    $177f118e50700877$var$renderedContainers.splice(0, $177f118e50700877$var$renderedContainers.length);
};

});
parcelRegister("dSsUz", function(module, exports) {

$parcel$export(module.exports, "SingleItemContainer", function () { return $a1a6beb3b9dfb529$export$a892e6728e3a29d; });

var $iSvIT = parcelRequire("iSvIT");
var $a1a6beb3b9dfb529$export$a892e6728e3a29d = function SingleItemContainer(_ref) {
    var initValue = _ref.initValue, useHookBody = _ref.useHookBody, applyStateChange = _ref.applyStateChange;
    var lastState = (0, $iSvIT.useRef)(initValue);
    if (typeof useHookBody !== "function") throw new Error("function expected as hook body parameter. got " + typeof useHookBody);
    var val = useHookBody();
    //useLayoutEffect is safe from SSR perspective because SingleItemContainer should never be rendered on server
    (0, $iSvIT.useLayoutEffect)(function() {
        if (lastState.current !== val) {
            lastState.current = val;
            applyStateChange(val);
        }
    }, [
        applyStateChange,
        val
    ]);
    return null;
};

});

parcelRegister("5LIXH", function(module, exports) {

$parcel$export(module.exports, "batch", function () { return $4334380b9c3ef7c8$export$712ea50be43a7858; });
$parcel$export(module.exports, "mount", function () { return $4334380b9c3ef7c8$export$186d02efde07ef98; });

var $iSvIT = parcelRequire("iSvIT");

var $01JF1 = parcelRequire("01JF1");

var $i5UxU = parcelRequire("i5UxU");

var $f5IT8 = parcelRequire("f5IT8");
// from https://github.com/purposeindustries/window-or-global/blob/master/lib/index.js
// avoid direct usage of 'window' because `window is not defined` error might happen in babel-node
var $4334380b9c3ef7c8$var$globalObject = typeof self === "object" && self.self === self && self || typeof $parcel$global === "object" && $parcel$global.global === $parcel$global && $parcel$global || undefined;
var $4334380b9c3ef7c8$export$712ea50be43a7858 = function batch(cb) {
    return (0, $i5UxU.unstable_batchedUpdates)(cb);
};
var $4334380b9c3ef7c8$export$186d02efde07ef98 = function mount(C) {
    if ($4334380b9c3ef7c8$var$globalObject.document && $4334380b9c3ef7c8$var$globalObject.document.createElement) {
        var container = $4334380b9c3ef7c8$var$globalObject.document.createElement("div");
        var root = (0, $01JF1.createRoot)(container);
        root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(C, {
            automaticContainerInternalUseOnly: true
        }));
    } else (0, $f5IT8.warning)("Can not mount SingletonHooksContainer on server side. Did you manage to run useEffect on server? Please mount SingletonHooksContainer into your components tree manually.");
};

});
parcelRegister("f5IT8", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $afca2483e637ced3$export$491112666e282270; });
var $afca2483e637ced3$export$491112666e282270 = function warning(message) {
    if (console && console.warn) console.warn(message);
};

});











//# sourceMappingURL=dynamic-content-type-page.7b086185.js.map
